<template>
	<div>
		<label
			:ref="labelRef"
			:for="labelFor"
		>
			<vue-six-four
				:id="inputId"
				hidden
				@vue-six-four="getFile"
			/>
			<v-btn
				class="btn-action caption"
				color="primary"
				@click="actionUploadImage"
			>
				{{buttonTitle}}
			</v-btn>
		</label>
	</div>
</template>

<script>
	import VueSixFour from 'vue-six-four';

	function actionUploadImage() {
		this.$refs[this.labelRef].click();
	}

	async function getFile(fileInfo) {
		this.isLoadingImage = true;
		const newFile = {
			name: fileInfo.name.replace(/\s/g, '-'),
			type: fileInfo.type,
			image: fileInfo.sixFour,
		};
		try {
			const words = newFile.name.split('.');
			const lastItem = words.length;
			const extension = words[lastItem - 1];
			if (this.allowedFiles.indexOf(extension) > -1) {
				const { data: response } = await this.$http.post('image/one-upload', newFile);
				if (extension === 'pdf') {
					this.$emit('send-file', { file: response.data.url_image });
					this.isLoadingImage = false;
				} else {
					const newImage = new Image();
					newImage.onload = () => {
						if (newImage.naturalWidth <= this.allowedMaxSize) {
							const model = {
								urlImage: response.data.url_image,
							};
							if (this.itemUpdate) {
								model.item = this.itemUpdate;
							}
							this.$emit('send-image', model);
							this.isLoadingImage = false;
						} else {
							this.showNotification(`El tamaño máximo permitido es ${this.allowedMaxSize} x ${this.allowedMaxSize}`,
								'warning');
							this.isLoadingImage = false;
						}
					};
					newImage.src = response.data.url_image;
				}
			} else {
				this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`,
					'warning');
			}
		} catch (error) {
			this.showError();
		}
	}

	function data() {
		return {
			allowedFiles: ['jpg', 'jpeg', 'png', 'svg', 'pdf'],
			isLoadingImage: false,
			newImage: '',
		};
	}

		export default {
		name: 'upload-image',
		components: {
			VueSixFour,
		},
		data,
		methods: {
			actionUploadImage,
			getFile,
		},
		props: {
			allowedMaxSize: {
				type: Number,
				default: 25
			},
			buttonTitle: {
				default: 'Cambiar de icono',
				type: String,
			},
			inputId: {
				type: [Number, String],
			},
			itemUpdate: {
				type: Object,
				default: () => {},
			},
			labelFor: {
				type: [Number, String],
			},
			labelRef: {
				type: [Number, String],
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/shared/upload-image.vue